import React, { useState, useEffect } from "react";
import ModalLyt from "../../../../components/Layouts/ModalLyt/ModalLyt";
import { Grid, Box, Typography } from "@mui/material";
import DyButton from "../../../../components/GlobalComponents/DyButton/DyButton";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";

import {
  useGetAllStrategies,
  useDeletePerson,
} from "../../Hooks/index";
import { Strategy } from "../Strategy/Strategy";
import EditStrategy from "../EditStrategy/EditStrategy";
import AddStrategy from "../AddStrategy/AddStrategy";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
const AllStrategy = ({periodsData,periodId}:any) => {
  const userId = useSelector((state: any) => state.loign.userInfo.userId);
  const userPhoneNumber = useSelector(
    (state: any) => state.loign.userPhoneNumber
  );
  const tenantId: string | null = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
  const { data: usersData, isLoading: getAllPeronsLoading,refetch:getAgain } =
  useGetAllStrategies(tenantId,periodId);
  const [personId, setPersonId] = useState<string | null>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه
  const [personIdFDelete, setPersonIdFDelete] = useState<string | null>(null);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const { mutate: deletePerson } = useDeletePerson();
  const [showAddStaff, setShowAddStaff] = useState<Boolean | null>(false);
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const [userAsynOpcState, setUserAsyncOpState] = useState<any>(null);
  const [showToastMessage2, setShowToastMessage2] = useState<boolean>(false);

  const initialAddStaff = () => {
    setShowAddStaff((prev: any) => !prev);
  };

  useEffect(() => {
    if (personIdFDelete) {
      let deleteBody = {
        phoneNumber: userPhoneNumber,
        lastModifiedById: userId,
        userId: userId,
        tenantId: tenantId,
      };
      console.log(deleteBody);
      deletePerson(deleteBody);
    }
  }, [personIdFDelete]);

  return (
    <Grid container>
      <Grid item xs={12} md={12} mx={2}>
        <Box display={"flex"} flexDirection={"row-reverse"} py={1} px={2}>
          <Box>
            <DyButton
              caption={"ایجاد استراتژی"}
              onClick={initialAddStaff}
              color={"red"}
              disbled={false}
              variant={"contained"}
              type={"button"}
              bgColor={"#00387C"}
            />
          </Box>
        </Box>

        {showAddStaff && (
          <ModalLyt
            showModal={showAddStaff}
            setShowModal={setShowAddStaff}
            height={500}
            width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"ایجاد استراتژی"}
          >
            <AddStrategy
              onSuccesss={initialAddStaff}
              periodsData={periodsData}
              onClose={setShowAddStaff}
              periodId={periodId}
              onSuccess={getAgain}
              setShowToastMessage2={setShowToastMessage2}
              setAddStaffState={setUserAsyncOpState}
            />
          </ModalLyt>
        )}

        {showEditModal && (
          <ModalLyt
            showModal={showEditModal}
            setShowModal={setShowEditModal}
            height={500}
            width={isMobile ? '350px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"ویرایش استراتژی"}
          >
            <EditStrategy
              personId={personId}
              afterSuccess={getAgain}
              onClose={setShowEditModal}
              setShowToastMessage={setShowToastMessage}
              setAddStaffState={setUserAsyncOpState}
            />
          </ModalLyt>
        )}
      </Grid>
      <Grid item xs={12}>
        {getAllPeronsLoading ? (
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            width={"99%"}
            py={15}
            boxShadow={4}
            borderRadius={3}
            mx={"auto"}
          >
            <CircularProgress />
          </Box>
        ) : usersData && usersData.length > 0 ? (
          <Box
            width={"100%"}
            display={"flex"}
            flexWrap={"wrap"}
            justifyContent={"start"}
            px={2}
          >
            {usersData.map((item: any, i: number) => (
              <Grid item xs={12} sm={6} key={i}>
               <Box
                    key={i}
                    sx={{
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                        backgroundColor: "withesmoke",
                        // boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.3)",
                        // borderRadius: "12px",
                      },
                      padding: "10px", // Add padding to ensure content isn't cut off during hover
                    }}
                  >
                  <Strategy
                    setShowEditModal={setShowEditModal}
                    setPersonId={setPersonId}
                    setPersonIdFDelete={setPersonIdFDelete}
                    item={item}
                    setShowToastMessage={setShowToastMessage}
                    setDeleteState={setUserAsyncOpState}
                  />
                </Box>
              </Grid>
            ))}
          </Box>
        ) : (
          <Grid container>
            <Box width={"100%"} textAlign={"center"} p={2}>
              <Typography
                textAlign={"center"}
                fontWeight={500}
                fontSize={"18px"}
                variant="body2"
              >
                استراتژی در این دوره‌‌زمانی تعریف نشده است.
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid>
      {/* <Grid item xs={12}>
        {getAllPeronsLoading ? (
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            width={"99%"}
            py={15}
            boxShadow={4}
            borderRadius={3}
            mx={"auto"}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box
            width={"100%"}
            display={"flex"}
            flexWrap={"wrap"}
            justifyContent={"start"}
            px={2}
          >
            {usersData &&
              usersData?.map((item: any, i: number) => {
                return (
                  <Grid item xs={12} sm={6}>
                       <Box width={"100%"} key={i}>
                  <Box key={i}>
                    <Strategy
                      setShowEditModal={setShowEditModal}
                      setPersonId={setPersonId}
                      setPersonIdFDelete={setPersonIdFDelete}
                      item={item}
                      setShowToastMessage={setShowToastMessage}
                      setDeleteState={setUserAsyncOpState}
                    />
                  </Box>
                  </Box>
                  </Grid>
                );
              })}
          </Box>
        )}
      </Grid> */}

      {showToastMessage && (
        <DYToastMessage
          isSuccess={userAsynOpcState?.isSuccess}
          message={userAsynOpcState?.metaData.message}
          setShow={setShowToastMessage}
          show={showToastMessage}
        />
      )}
      {showToastMessage2 && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage2}
            show={showToastMessage2}
          />
        )}
            <Grid item xs={12}>
       <Box width={'100%'} height={'15px'}>
    </Box>
    </Grid>
    </Grid>
    
  );
};

export default AllStrategy;

//
